'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveProductLinks = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _optimizely = require('helpers/optimizely');

var Optimizely = _interopRequireWildcard(_optimizely);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LiveProductLinks = exports.LiveProductLinks = function LiveProductLinks() {
  var liveSellLink = Optimizely.isActiveVariationByName('CP Live Sell Page', 'New Sell Page') ? '/live/try' : '/live/trial';

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: liveSellLink },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.live',
          defaultMessage: 'ClassPass Live'
        })
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/live/features' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.live.features',
          defaultMessage: 'How it works'
        })
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/pricing/live' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.live.pricing',
          defaultMessage: 'Pricing'
        })
      )
    )
  );
};